import React from "react";
import {Button, FormControl, Grid, TextField} from "@mui/material";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {DefaultEventProps} from "@models/DefaultProps.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {useValidacao} from "@shared/hooks/useValidacao.ts";
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";
import {ICreateUsuarioDto} from "@components/usuario/dto/input/ICreateUsuarioDto.ts";

interface CreateContaComponentProps extends Pick<DefaultEventProps<IUsuario>, 'onCreate'> {
}

export function CreateUsuarioComponent(props: CreateContaComponentProps) {
    const {onCreate} = props;
    const {isEmailValido} = useValidacao()
    const [dados, setDados] = React.useState<ICreateUsuarioDto>({
        nome: '',
        email: ''
    })

    const {createUsuario} = useUsuario()
    const {createAlertFromResponse} = useAlert()

    const createContaHandler = async () => {
        await createUsuario(dados).then(res => {
            createAlertFromResponse(res)
            if (res.status == 'Success') {
                if (onCreate != null) {
                    onCreate(res.items)
                }
            }
        })
    }

    return (
        <FormControl>
            <Grid container>
                <Grid size={12}>
                    <TextField required label={'Nome do usuario'}
                               value={dados.nome}
                               error={dados.nome.length < 4}
                               onChange={(e) => {
                                   setDados({...dados, nome: e.target.value})
                               }}/>
                </Grid>
                <Grid size={12}>
                    <TextField required label={'Email'}
                               value={dados.email}
                               error={!isEmailValido(dados.email)}
                               onChange={(e) => {
                                   setDados({...dados, email: e.target.value})
                               }}/>
                </Grid>
                <Grid size={12}>
                    <Button onClick={createContaHandler}
                            disabled={!isEmailValido(dados.email) || dados.nome.length < 4}
                            fullWidth>
                        Criar
                    </Button>
                </Grid>
            </Grid>
        </FormControl>
    )
}